import { render, staticRenderFns } from "./courceDialog.vue?vue&type=template&id=20ace4be"
import script from "./courceDialog.vue?vue&type=script&lang=js"
export * from "./courceDialog.vue?vue&type=script&lang=js"
import style0 from "./courceDialog.vue?vue&type=style&index=0&id=20ace4be&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports